import React from "react";

let APP_LINK = window.location.origin;
if (!APP_LINK.includes("mirea")) {
  APP_LINK = "https://priem.mirea.ru"
}

export const LinkContext = React.createContext<string>(APP_LINK);